import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import {
  getIsViewingRowActive,
  renderViewingCell,
} from './RentalPortalViewingTableRow.utils'

import * as styles from './RentalPortalViewingTableRow.module.css'

function RentalPortalViewingTableRow({
  actionLeft,
  actionsColumnWidth,
  activeItem,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  showCellBorder,
  onClickApplicant,
  ...restProps
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const className = useTableRowModClassName({
    className: styles.RentalPortalViewingTableRow,
    isActive: getIsViewingRowActive({ activeItem, focusedRow, id: item.id }),
    isSelected,
  })

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableRowActions
        disabled={hideCheckbox}
        selected={isSelected}
        width={actionsColumnWidth}
        onChange={handleSelect}
      />
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderViewingCell({
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            locale,
            name: column.name,
            showCellBorder,
            t,
            timezone,
            width: column.width,
            onClickApplicant,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalViewingTableRow
